import NoRecordFound from "../../../../../../components/ui/noRecordFound/NoRecordFound";
import { CERTIFICATE_TYPE } from "./certificateTypes";


const EXTRA_COLUMNS = {
  [CERTIFICATE_TYPE.TVOC]: [
    { header: "Text Value", field: "textValue" },
    { header: "TVOC Emission", field: "tvocEmission" },
    { header: "Formaldehyde Emission", field: "formaldehydeEmission" },
  ],
  [CERTIFICATE_TYPE.GWP_GENERAL]: [{ header: "Declared GWP (A1-A3)", field: "additionalFieldValue" }],
  [CERTIFICATE_TYPE.GWP_CONCRETE]: [],
  [CERTIFICATE_TYPE.COMMON]: [],
};

const ReadOnlyCell = ({ value }) => (
  <div className="input-group">
    <input type="text" className="form-control" value={value ?? ""} disabled />
  </div>
);

const ModalGroupingTable = ({ type, data = [] }) => {
  const extraColumns = EXTRA_COLUMNS[type] ?? [];

  if (data.length === 0) return <NoRecordFound />;

  return (
    <div className="member-list">
      <div className="content-section">
        <div className="table-section">
          <table>
            <thead>
              <tr>
                <th>Brand Name</th>
                <th>Model Name</th>
                <th>Rating</th>
                {extraColumns.map((col) => (
                  <th key={col.field}>{col.header}</th>
                ))}
                <th>Cert Number</th>
                <th>Cert Suffix</th>
              </tr>
            </thead>
            <tbody>
              {data.map((item, index) => (
                <tr key={item.sgbpProductId ?? index}>
                  <td>{item.brandName || "N/A"}</td>
                  <td>{item.modelName || "N/A"}</td>
                  <td><ReadOnlyCell value={item.rating} /></td>
                  {extraColumns.map((col) => (
                    <td key={col.field}><ReadOnlyCell value={item[col.field]} /></td>
                  ))}
                  <td><ReadOnlyCell value={item.applicationNumber} /></td>
                  <td><ReadOnlyCell value={item.certPrefix} /></td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default ModalGroupingTable;